import { HONEYPOT_FIELD } from "@/lib/rate-limit";

/**
 * A field only a bot fills in.
 *
 * Hidden from sight, from assistive tech (`aria-hidden`) and from keyboard
 * navigation (`tabIndex={-1}`), and marked `autoComplete="off"` so a browser's
 * autofill does not helpfully trip it on a real person's behalf. Positioned
 * off-screen rather than `display:none`, because the simplest scrapers do skip
 * `display:none` inputs.
 *
 * Chosen over a third-party CAPTCHA deliberately: no external script, no
 * consent question, no accessibility cost, and nothing to pay for. It stops the
 * naive bots, which is most of them; the per-IP throttle in rate-limit.ts is
 * what stops the rest.
 */
export function HoneypotField() {
  return (
    <div aria-hidden className="absolute left-[-9999px] top-auto h-px w-px overflow-hidden">
      <label htmlFor={HONEYPOT_FIELD}>Company website</label>
      <input
        id={HONEYPOT_FIELD}
        type="text"
        name={HONEYPOT_FIELD}
        tabIndex={-1}
        autoComplete="off"
        defaultValue=""
      />
    </div>
  );
}
